import { DataElement } from "./common";

export class OperationReport {
  reportId: number;
  reportType: string;
  reportDescr: string;
  params: ReportParam[] = [];

  clearParams() {
    this.params.forEach((p) => {
      p.valueDate = null;
      p.valueNumber = null;
      p.valueElement = null;
      p.valueElementList = [];
      p.valueText = null;
    });
  }
}

export class ReportParam {
  paramCode: string;
  paramDescr: string;
  type: ReportParamTypeEnum;
  listType: string;
  maxListLength: number;
  default: any;
  requiredSw: boolean;
  sortOrder: number;
  customList: DataElement[] = [];
  loading: boolean;
  valueElementList: DataElement[] = [];
  valueElement: DataElement;
  valueDate: Date;
  valueNumber: number;
  valueText: string;

  validate(): boolean {
    let valid = true;
    if (this.requiredSw) {
      switch (this.type) {
        case ReportParamTypeEnum.LIST:
          if (this.maxListLength == 1) {
            valid = this.valueElement != null;
          } else if (this.maxListLength == 0) {
            valid = this.valueElementList.length > 0;
          } else {
            valid =
              this.valueElementList.length > 0 &&
              this.valueElementList.length <= this.maxListLength;
          }
          break;
        case ReportParamTypeEnum.CUSTOM_LIST:
          if (this.maxListLength == 1) {
            valid = this.valueElement != null;
          } else if (this.maxListLength == 0) {
            valid = this.valueElementList.length > 0;
          } else {
            valid =
              this.valueElementList.length > 0 &&
              this.valueElementList.length <= this.maxListLength;
          }
          break;
        case ReportParamTypeEnum.NUMBER:
          valid = this.valueNumber != null;
          break;
        case ReportParamTypeEnum.DATE:
          valid = this.valueDate != null;
          break;
        case ReportParamTypeEnum.TEXT:
          valid = this.valueText != null;
          break;
        case ReportParamTypeEnum.TEXTAREA:
          valid = this.valueText != null;
          break;
        default:
          break;
      }
    }
    return valid;
  }
}

export class ReportRunStatusResult {
  status: ProcessRunStatusEnum;
  errorCode: string;
  errorMsg: string;
  outFileUrl: string;
}

export class ProcessRunStatusEnum {
  public static PENDING: string = "PENDING";
  public static RUNNING: string = "RUNNING";
  public static FINISHED: string = "DONE";
  public static FAILED: string = "ERROR";
}

export class ReportParamTypeEnum {
  static CUSTOM_LIST: string = "CUSTOM_LIST";
  static LIST: string = "LIST";
  static DATE: string = "DATE";
  static NUMBER: string = "NUMBER";
  static TEXT: string = "TEXT";
  static TEXTAREA: string = "TEXTAREA";
}

export class ReportTypeEnum {
  static FINANCE: string = "FINANCE";
  static MARKETING: string = "MARKETING";
  static PLANT: string = "PLANT";
  static OPERATIONS: string = "OPERATIONS";
}

export class ReportListTypeEnum {
  static CLINICS: string = "CLINICS";
  static AGENTS: string = "AGENTS";
}
